import { FC } from "react";
import styles from "./Footer.module.scss";
import cn from "classnames";
import { Link } from "react-router-dom";
import { getScreenSize } from "@utils/getScreenSize";

const Footer: FC = () => {
    const { isMobile } = getScreenSize();
    return (
        <footer className={styles.footer + " px-4"}>
            <div className={styles.container}>
                <div className={styles.content + " !rounded-4xl"}>
                    <div className={styles.left}>
                        <img src="/images/header/logo.svg" width={78} height={18} alt="Nest logo" />
                        <p className={styles.description}>
                            Nest is a DEX focused on the speed of transactions in the TON network
                        </p>
                        <div className={styles.icons}>
                            <a href="https://t.me/nest_dex">
                                <svg
                                    className={styles.icon}
                                    width="18"
                                    height="14"
                                    viewBox="0 0 18 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <desc>Telegram</desc>
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M1.88429 6.13663C6.31346 4.20689 9.26694 2.93469 10.7447 2.32003C14.9641 0.565035 15.8408 0.260174 16.4123 0.250107C16.538 0.247893 16.819 0.279042 17.001 0.426752C17.1547 0.551475 17.197 0.719959 17.2173 0.83821C17.2375 0.956462 17.2627 1.22584 17.2427 1.43633C17.014 3.83878 16.0247 9.66889 15.5213 12.3597C15.3083 13.4982 14.889 13.88 14.483 13.9174C13.6007 13.9985 12.9307 13.3343 12.0762 12.7741C10.7389 11.8975 9.9835 11.3519 8.6855 10.4965C7.18544 9.50796 8.15787 8.96465 9.01275 8.07673C9.23647 7.84435 13.1239 4.30838 13.1992 3.98761C13.2086 3.94749 13.2173 3.79795 13.1285 3.71899C13.0396 3.64003 12.9085 3.66703 12.8139 3.6885C12.6798 3.71894 10.5436 5.13091 6.40526 7.92442C5.7989 8.34079 5.24968 8.54366 4.7576 8.53303C4.21512 8.52131 3.1716 8.2263 2.39586 7.97413C1.44437 7.66484 0.688147 7.50132 0.753997 6.97604C0.788296 6.70245 1.16506 6.42264 1.88429 6.13663Z"
                                        fill="rgb(130, 127, 255, .4)"
                                    />
                                </svg>
                            </a>
                            {/*<a href="/">
        <svg
         className={styles.icon}
         width="16"
         height="14"
         viewBox="0 0 16 14"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
        >
         <desc>X (Twitter)</desc>
         <path
          d="M12.3134 0.25H14.6135L9.58844 5.96846L15.5 13.75H10.8713L7.24593 9.03054L3.09769 13.75H0.796204L6.17098 7.63346L0.5 0.25H5.24621L8.52322 4.56377L12.3134 0.25Z"
          fill="rgb(130, 127, 255, .4)"
         />
        </svg>
       </a>*/}
                        </div>
                        {!isMobile && <p className={styles.copyright}>2024 © nest. All rights reserved</p>}
                    </div>
                    <div className={styles.right}>
                        <ul className={styles.list}>
                            <li className={cn(styles.item, styles.title)}>Products</li>
                            <li className={styles.item}>
                                <Link to="/">Fast transaction</Link>
                            </li>
                            <li className={styles.item}>
                                <Link to="/">Sniper bot</Link>
                            </li>
                            <li className={styles.item}>
                                <Link to="/profile">Referrals</Link>
                            </li>
                        </ul>
                        <ul className={styles.list}>
                            <li className={cn(styles.item, styles.title)}>About</li>

                            <li className={styles.item}>
                                <a href="/">DEX</a>
                            </li>
                            <li className={styles.item}>
                                <a href="/">Token</a>
                            </li>
                        </ul>
                        <ul className={styles.list}>
                            <li className={cn(styles.item, styles.title)}>Checkers</li>

                            {/* <li className={styles.item}>
        <Link to="/scam">SCAM checker</Link>
       </li>
       <li className={styles.item}>
        <Link to="/whale">Whale checker</Link>
       </li>
      </ul>
      <ul className={styles.list}>
       <li className={cn(styles.item, styles.title)}>Solutions</li>
       <li className={styles.item}>
        <Link to="/support">Help & Support</Link>
       </li> */}
                            <li className={styles.item}>
                                <Link to="/pricing">Pricing</Link>
                            </li>
                            <li className={styles.item}>
                                <Link to="/news">News</Link>
                            </li>
                            <li className={styles.item}>
                                <a
                                    target="_blank"
                                    href="https://docs.google.com/document/d/1jiFfF1NblfXCKmp7_CYyU8FlpKTCFVXak55C4U-0SVw/edit?usp=sharing"
                                >
                                    Privacy policy
                                </a>
                            </li>
                            <li className={styles.item}>
                                <a
                                    target="_blank"
                                    href="https://docs.google.com/document/d/1vgKMm1pBTGe4PvNiHUkaY3RdC5zzfsjHqm3mk9VFFWs/edit?usp=sharing"
                                >
                                    Term of use
                                </a>
                            </li>
                        </ul>
                    </div>
                    {isMobile && <p className={styles.copyright}>2024 © nest. All rights reserved</p>}
                </div>
            </div>
        </footer>
    );
};

export default Footer;
